
<div class=" heading">
    <h1>CREATE COURSE FEE </h1>
    <i class="fa fa-times-circle fa-lg" id="closeimage" (click)="close()"></i>
   </div>
   <form class="main  form" [formGroup]="main">
      
       <div id="selections" class=" main ">
         <span class="selection" id="city">
           <mat-label class="fontsize">City</mat-label>
           <mat-select class="selectOptions"placeholder="{{defaultCity}}" (click)="toResetCityIntput()" formControlName="citycontrol2">
             <input matInput [matAutocomplete]="cityauto" autofocus formControlName="citycontrol" class="inputborder"
               placeholder="select city">
             <mat-autocomplete  #cityauto="matAutocomplete"></mat-autocomplete>
             <mat-option *ngFor="let item of cityOptions | async" [value]="item"
               (click)="getcityid(item)" (click)="clearcampus()">{{item.cityName}}</mat-option>
           </mat-select>
         </span>
         <span class="selection" id="Campus">
           <mat-label class="fontsize">Campus</mat-label>
           <mat-select class="selectOptions"placeholder="{{defaultCampus}}" (click)="toResetCampusIntput()" formControlName="campusControl2">
             <input matInput [matAutocomplete]="campusauto" autofocus formControlName="campusControl" class="inputborder"
               placeholder="select Campus">
             <mat-autocomplete autoActiveFirstOption #campusauto="matAutocomplete"></mat-autocomplete>
             <mat-option *ngFor="let campus of campusOptions | async" (click)="getclass(campus)" (click)="clearclass()"[value]="campus">
               {{campus.campusName}}</mat-option>
           </mat-select>
         </span>
         <span class="selection" id="Class">
           <mat-label class="fontsize">Class</mat-label>
           <mat-select class="selectOptions"placeholder="{{defaultClass}}" (click)="toResetClassIntput()" formControlName="classControl2">
             <input matInput [matAutocomplete]="classauto" autofocus formControlName="classControl" class="inputborder border"
               placeholder="select Class" (click)="clearstream()">
             <mat-autocomplete autoActiveFirstOption #classauto="matAutocomplete"></mat-autocomplete>
             <mat-option *ngFor="let class of classOptions | async" (click)="getclassId(class)"(click)="clearGroup()" [value]="class">
               {{class.className}}</mat-option>
           </mat-select>
         </span>
         <span class="selection" id="Group">
           <mat-label class="fontsize">Group</mat-label>
           <mat-select class="selectOptions"placeholder="{{defaultgroup}}" (click)="toResetGroupIntput()" formControlName="groupcontrol2">
             <input matInput [matAutocomplete]="groupauto" autofocus formControlName="groupcontrol" class="inputborder border"
               placeholder="select Group">
             <mat-autocomplete autoActiveFirstOption #groupauto="matAutocomplete"></mat-autocomplete>
             <mat-option *ngFor="let group of groupOptions | async" [value]="group" (click)="getGroupobj(group) ">{{group.groupName}}</mat-option>
           </mat-select>
         </span>
         <span class="selection" id="Stream">
           <mat-label class="fontsize">Stream</mat-label>
           <mat-select class="selectOptions"placeholder="{{defaultstream}}" (click)="toResetStreamIntput()" formControlName="streamcontrol2">
             <input matInput [matAutocomplete]="streamauto" autofocus formControlName="streamcontrol" class="inputborder border"
               placeholder="select stream" >
             <mat-autocomplete autoActiveFirstOption #streamauto="matAutocomplete"></mat-autocomplete>
             <mat-option *ngFor="let stream of streamOptions | async" (click)="clearcoursetrack()" (click)=" getcourseTrack(stream)"
               [value]="stream">{{stream.streamName}}</mat-option>
           </mat-select>
         </span>
         <span class="selection" id="CourseTrack">
           <mat-label class="fontsize"[style.color]="coursetrackcolor1">CourseTrack</mat-label>
           <mat-select class="selectOptions"placeholder="{{defaultCoursetrack}}" (click)="toResetCourseTrackIntput()" [style.border-color]="coursetrackcolor"formControlName="coursetrackcontrol2">
             <input matInput [matAutocomplete]="coursetrackauto" autofocus formControlName="coursetrackcontrol" class="inputborder"
               placeholder="select coursetrack name">
             <mat-autocomplete autoActiveFirstOption #coursetrackauto="matAutocomplete"></mat-autocomplete>
             <mat-option *ngFor="let CourseTrack of campustrackOptions | async" (click)="setcoursetrackid(CourseTrack)"
               [value]="CourseTrack">{{CourseTrack.courseTrackName}}</mat-option>
           </mat-select>
         </span>
       </div>
       <div id="bottombutton">
           <button id="get" (click)="get()">Get</button>
           <button id="create" (click)="verifycoursetrack()">create</button>
       </div>
     </form>
    
     <!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>